// added by evan@cooeecommerce.com

document.addEventListener("DOMContentLoaded", (event) => {

  // product page sticky bar
  if (document.body.classList.contains('template-product')) {
    window.onscroll = function() {stickyBar()};
    function stickyBar() {
      var sticky = document.querySelector(".product-sticky-section");
      if (document.documentElement.scrollTop > 250) {
        sticky.classList.add("product-sticky-section--stuck");
      } else {
        sticky.classList.remove("product-sticky-section--stuck");
      }
    };
  }

  // check current_variant.inventory_policy on product page load
  if (document.body.classList.contains('template-product')) {
    document.body.onload = function() {checkPolicy()};
    function checkPolicy() {
      if(invPolicy == "deny") {
        document.querySelector("#final-sale").style.display = "block";
        document.querySelector("#final-sale-property").value = "true";
      }
    };
  }

  // update values on variant change - product page sticky bar & custom inventory block
  document.addEventListener('variant:change', function(evt) {
    console.log(evt.detail.variant);
    var newVariant = evt.detail.variant.title;
    document.querySelector(".product-sticky-section__option").innerText = newVariant;
    var newPrice = evt.detail.variant.price;
    document.querySelector(".product-sticky-section__price").innerHTML = theme.Currency.formatMoney(newPrice, theme.settings.moneyFormat);
    var newQuantity = variantStock[evt.detail.variant.id];
    document.getElementsByName("properties[backorder]")[0].value = "";
    if (newQuantity < 1) {
  		document.querySelector(".inventoryWrapper").innerHTML = "<p style='color: red';>" + backorderMessage + "</p>";
        document.querySelector("[data-add-to-cart-text]").innerText = backorderButton;
        document.getElementsByName("properties[backorder]")[0].value = "true";
  	} else if (newQuantity > 5) {
  		document.querySelector(".inventoryWrapper").innerHTML = "<p>" + inStockMessage + "</p>";
  	} else if (newQuantity == 1) {
  		document.querySelector(".inventoryWrapper").innerHTML = "<p>Only " + newQuantity + " item in stock!</p>";
  	} else {
  		document.querySelector(".inventoryWrapper").innerHTML = "<p>Only " + newQuantity + " items in stock!</p>";
  	};
    // check variant inventory_policy
    var newPolicy = variantPolicy[evt.detail.variant.id];
    if(newPolicy == "deny") {
        document.querySelector("#final-sale").style.display = "block";
        document.querySelector("#final-sale-property").value = "true";
    } else {
        document.querySelector("#final-sale").style.display = "none";
        document.querySelector("#final-sale-property").value = "false";
    };
  });

  // show/hide backorder terms checkbox on cart page/drawer if backorder product is added/removed
  document.addEventListener('cart:updated', function(evt) {
    let cartItems = evt.detail.cart.items;
    let x = 0;
    for (let i = 0; i < cartItems.length; i++) {
      let cartProperty = cartItems[i].properties;
      if (cartProperty.backorder == "true") {
        x++;
      }
    };
    //console.log(x);
    if (x > 0) {
      if (document.querySelector(".cart__terms.backorder.cart-page") !== null) {
        document.querySelector(".cart__terms.backorder.cart-page").style.display = "flex";
        document.getElementById("BackorderTerms").checked = false;
      }
      if (document.querySelector(".cart__terms.backorder.cart-drawer") !== null) {
        document.querySelector(".cart__terms.backorder.cart-drawer").style.display = "flex";
        document.getElementById("BackorderTermsDrawer").checked = false;
      }
    } else {
      if (document.querySelector(".cart__terms.backorder.cart-page") !== null) {
        document.querySelector(".cart__terms.backorder.cart-page").style.display = "none";
        document.getElementById("BackorderTerms").checked = true;
      }
      if (document.querySelector(".cart__terms.backorder.cart-drawer") !== null) {
        document.querySelector(".cart__terms.backorder.cart-drawer").style.display = "none";
        document.getElementById("BackorderTermsDrawer").checked = true;
      }
    }
  });

  // show backorder terms checkbox in cart drawer if backorder product is added
  document.addEventListener('ajaxProduct:added', function(evt) {
    //console.log(evt.detail.product);
    if (evt.detail.product.properties.backorder == "true") {
      document.querySelector(".cart__terms.backorder.cart-drawer").style.display = "flex";
      document.getElementById("BackorderTermsDrawer").checked = false;
    }
  });

});